import { render, staticRenderFns } from "./TenderInfoBlock.vue?vue&type=template&id=e78b1fc6&scoped=true"
import script from "./TenderInfoBlock.vue?vue&type=script&lang=js"
export * from "./TenderInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./TenderInfoBlock.vue?vue&type=style&index=0&id=e78b1fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78b1fc6",
  null
  
)

export default component.exports